function getWebpUrl(src: string): string {
    const dotPostion = src?.lastIndexOf(".");
    return dotPostion > 0 ? `${src.slice(0, dotPostion)}.webp` : src;
}

export default getWebpUrl;
